/* eslint-disable ember/no-classic-components, ember/no-component-lifecycle-hooks, ember/require-tagless-components */
import { classNames, tagName } from '@ember-decorators/component';
import Component from '@ember/component';

@tagName('span')
@classNames('reporting-progress-number')
export default class ReportingProgressNumber extends Component {
  value = null;

  didInsertElement() {
    super.didInsertElement(...arguments);
    this._previousValue = this.value;
  }

  didUpdate() {
    super.didUpdate(...arguments);
    if (this._previousValue !== this.value) {
      this._previousValue = this.value;
      this.element.classList.remove('reporting-progress-bump');
      void this.element.offsetWidth;
      this.element.classList.add('reporting-progress-bump');
    }
  }
}
